module.exports = __webpack_public_path__ + "img/4.ba1129e.png";